// import { actionList, badgeDinamicState, nameLink, statusActiveOptions } from "../commons/commonFunctions"
import { useEffect, useState } from 'react'
import { Navigation, Settings } from 'react-feather'
import { Link } from 'react-router-dom'
import { Badge } from 'reactstrap'
import { fetch } from '../../utility/helpers/Axios/fetch'

const badgeStyle = {
    borderRadius: '10px',
    fontSize: '10px',
    color: 'white',
    background: '#079607',
    padding: '3px 9px 3px 9px',
    opacity: 0.77
}

export const subscriptionsList = [
    {
        name: 'Url',
        selector: 'url',
        sortable: true,
        searchable: true,
        width: '25%',
        cell: row => {
            return <a style={{ textDecoration: 'none' }} href={`${row.domain?.url}`} target="_blank">{row.domain?.url} </a>
        }
    },
    {
        name: 'Acceder',
        selector: 'url',
        sortable: true,
        searchable: true,
        width: '23%',
        cell: row => {
            return <a className='btn btn-sm btn-success' href={`${row.domain?.url}`} target="_blank">Acceder </a>
        }
    },
    {
        name: 'Nº Usuarios',
        selector: 'enable',
        sortable: true,
        searchable: true,
        width: '15%',
        cell: (row) => {
            const [subs, setSubs] = useState(0)
            const loadSubs = async () => {
                const subs = await fetch('Subscriptions', null, { filter: `domainId||$eq||${row.domainId}` }, 'GET')
                setSubs(subs.length)
            }

            useEffect(() => {
                loadSubs()
            }, [])

            const activeLicense = row.domain?.licenses?.find(license => license?.active)
            return <span className='text-justify w-100'>{subs} / {activeLicense?.userQty}</span>
        }
    },
    {
        name: 'Activo',
        selector: 'enable',
        sortable: true,
        searchable: true,
        width: '10%',
        cell: (row) => {
            return row.domain?.enable ?
                <Badge style={{ background: '#56ad56' }}> Activo</Badge> :
                <Badge style={{ background: '#d66464' }}> Inactivo</Badge>
        }
    },
    {
        name: 'Tipo de licencia',
        selector: 'enable',
        sortable: true,
        searchable: true,
        width: '17%',
        cell: (row) => {
            const activeLicense = row.domain?.licenses?.find(license => license?.active)
            return activeLicense?.type === 0 ?
                <span>Estandar</span> : activeLicense?.type === 1 ?
                    <span>Multi-centro</span> :
                    <span></span>
        }
    },
    {
        name: 'Acciones',
        selector: 'id',
        sortable: true,
        searchable: true,
        width: '10%',
        cell: row => {
            return row.isOwner ?
                <Link to={`/domains/${row.domainId}`}>
                    <Settings />
                </Link>
                : <span></span>

        }
    }
]